import {
    CcLibraryItem,
    CcLibraryItemList,
    CcReviewComplianceRevision,
    CcReviewComplianceHistory,
    CcReviewComplianceItemState,
    CcReviewComplianceTempAnswer,
    CcReviewComplianceTempAnswerVersion,
} from "server/models"
import { StateType } from "client/utils"
import { CcLibrarySetList } from "client/store"
import { TableGroupedIds, NestedHistory } from "client/components"

export interface CcReviewComplianceProps {
    setId: number
    revisionId: number
    complianceItemId: number
}

export type ReviewComplianceRevisionList = { [setId: number]: readonly CcReviewComplianceRevision[] }
export type ReviewComplianceRevisionActiveList = { [setId: number]: CcReviewComplianceRevision }
export type ReviewComplianceRevisionVersionActiveList = { [versionId: number]: ReviewComplianceRevisionActiveList }
export type ReviewComplianceRevisionValidation = { [key in keyof CcReviewComplianceRevision]?: string }

export type ReviewComplianceStateList = { [itemId: number]: CcReviewComplianceItemState }
export type ReviewComplianceVersionStateList = { [versionId: number]: ReviewComplianceStateList }

export type ReviewComplianceHistoryList = { [itemId: number]: CcReviewComplianceHistory[] }
export type ReviewComplianceHistoryNestedList = { [itemId: number]: NestedHistory[] }
export type ReviewComplianceVersionHistoryList = { [versionId: number]: ReviewComplianceHistoryList }
export type ReviewComplianceVersionHistoryNestedList = { [versionId: number]: ReviewComplianceHistoryNestedList }
export type ReviewComplianceHistoryValidation = { [key in keyof CcReviewComplianceHistory]?: string }

export type ReviewComplianceTempAnswerByUser = { [userId: number]: CcReviewComplianceTempAnswer }
export type ReviewComplianceTempAnswerList = { [itemId: number]: ReviewComplianceTempAnswerByUser }
export type ReviewComplianceTempAnswerValidation = { [key in keyof CcReviewComplianceTempAnswer]?: string }

export type ReviewComplianceTempAnswerVersionByUser = { [userId: number]: CcReviewComplianceTempAnswerVersion[] }

export interface CcReviewComplianceState {
    // list
    formalTableClass: string
    reviewTableClass: string

    showFormalColumnSettings: boolean
    showReviewColumnSettings: boolean

    itemList: CcLibraryItemList
    itemGroupedIds: { [setId: number]: TableGroupedIds }

    setList: CcLibrarySetList
    setIds: readonly number[]

    revisionList: ReviewComplianceRevisionList
    revisionActiveList: ReviewComplianceRevisionVersionActiveList

    itemStateList: { [setId: number]: ReviewComplianceStateList }
    itemHistoryList: { [setId: number]: ReviewComplianceHistoryList }
    tempAnswerList: { [setId: number]: ReviewComplianceTempAnswerList }

    // selected items
    formalSelectedItemIds: readonly number[]
    formalVisibleItemIds: readonly number[]
    reviewSelectedItemIds: readonly number[]
    reviewVisibleItemIds: readonly number[]

    setLoadState: StateType
    itemLoadState: StateType

    // popup menu
    active: CcLibraryItem
    menuShow: boolean
    menuTarget: any

    // view history
    itemDetails: CcLibraryItem
    itemState: CcReviewComplianceItemState
    itemHistory: CcReviewComplianceHistory[]
    tempAnswers: ReviewComplianceTempAnswerByUser
    tempAnswerVersions: ReviewComplianceTempAnswerVersionByUser
    tempAnswerHistory: CcReviewComplianceHistory
    reloadAnswer: boolean
}


// list
export const CC_REVIEW_COMPLIANCE_FORMAL_COLUMN_SETTINGS = "CC_REVIEW_COMPLIANCE_FORMAL_COLUMN_SETTINGS"
export const CC_REVIEW_COMPLIANCE_COLUMN_SETTINGS = "CC_REVIEW_COMPLIANCE_COLUMN_SETTINGS"

export const CC_REVIEW_COMPLIANCE_ITEM_LIST = "CC_REVIEW_COMPLIANCE_ITEM_LIST"
export const CC_REVIEW_COMPLIANCE_ITEM_GROUPED_IDS = "CC_REVIEW_COMPLIANCE_ITEM_GROUPED_IDS"
export const CC_REVIEW_COMPLIANCE_CLEAR_ITEM_GROUPED_IDS = "CC_REVIEW_COMPLIANCE_CLEAR_ITEM_GROUPED_IDS"

export const CC_REVIEW_COMPLIANCE_SET_LIST = "CC_REVIEW_COMPLIANCE_SET_LIST"
export const CC_REVIEW_COMPLIANCE_SET_IDS = "CC_REVIEW_COMPLIANCE_SET_IDS"

export const CC_REVIEW_COMPLIANCE_REVISION_LIST = "CC_REVIEW_COMPLIANCE_REVISION_LIST"
export const CC_REVIEW_COMPLIANCE_REVISION_ACTIVE_LIST = "CC_REVIEW_COMPLIANCE_REVISION_ACTIVE_LIST"

export const CC_REVIEW_COMPLIANCE_ITEM_STATE_LIST = "CC_REVIEW_COMPLIANCE_ITEM_STATE_LIST"
export const CC_REVIEW_COMPLIANCE_ITEM_HISTORY_LIST = "CC_REVIEW_COMPLIANCE_ITEM_HISTORY_LIST"
export const CC_REVIEW_COMPLIANCE_TEMP_ANSWER_LIST = "CC_REVIEW_COMPLIANCE_TEMP_ANSWER_LIST"

// selected items
export const CC_REVIEW_COMPLIANCE_FORMAL_SELECTED_ITEM_IDS = "CC_REVIEW_COMPLIANCE_FORMAL_SELECTED_ITEM_IDS"
export const CC_REVIEW_COMPLIANCE_FORMAL_VISIBLE_ITEM_IDS = "CC_REVIEW_COMPLIANCE_FORMAL_VISIBLE_ITEM_IDS"
export const CC_REVIEW_COMPLIANCE_SELECTED_ITEM_IDS = "CC_REVIEW_COMPLIANCE_SELECTED_ITEM_IDS"
export const CC_REVIEW_COMPLIANCE_VISIBLE_ITEM_IDS = "CC_REVIEW_COMPLIANCE_VISIBLE_ITEM_IDS"

export const CC_REVIEW_COMPLIANCE_SET_LOAD_STATE = "CC_REVIEW_COMPLIANCE_SET_LOAD_STATE"
export const CC_REVIEW_COMPLIANCE_ITEM_LOAD_STATE = "CC_REVIEW_COMPLIANCE_ITEM_LOAD_STATE"

// popup menu
export const CC_REVIEW_COMPLIANCE_ACTIVE = "CC_REVIEW_COMPLIANCE_ACTIVE"
export const CC_REVIEW_COMPLIANCE_POPUP_MENU_SHOW = "CC_REVIEW_COMPLIANCE_POPUP_MENU_SHOW"
export const CC_REVIEW_COMPLIANCE_POPUP_MENU_TARGET = "CC_REVIEW_COMPLIANCE_POPUP_MENU_TARGET"

// view history
export const CC_REVIEW_COMPLIANCE_ITEM_DETAILS = "CC_REVIEW_COMPLIANCE_ITEM_DETAILS"
export const CC_REVIEW_COMPLIANCE_ITEM_STATE = "CC_REVIEW_COMPLIANCE_ITEM_STATE"
export const CC_REVIEW_COMPLIANCE_ITEM_HISTORY = "CC_REVIEW_COMPLIANCE_ITEM_HISTORY"
export const CC_REVIEW_COMPLIANCE_TEMP_ANSWERS = "CC_REVIEW_COMPLIANCE_TEMP_ANSWERS"
export const CC_REVIEW_COMPLIANCE_TEMP_ANSWER_VERSIONS = "CC_REVIEW_COMPLIANCE_TEMP_ANSWER_VERSIONS"
export const CC_REVIEW_COMPLIANCE_TEMP_ANSWER_HISTORY = "CC_REVIEW_COMPLIANCE_TEMP_ANSWER_HISTORY"
export const CC_REVIEW_COMPLIANCE_RELOAD_ANSWER = "CC_REVIEW_COMPLIANCE_RELOAD_ANSWER"
